export const dehydrateFormData = (formData: any) => {
	const { commonTransactionMessage, txnMessage, typeBucket, txnHeading, sendInAppNotificationAlso } = formData;
	const csvData = {
		...formData,
		...(commonTransactionMessage ? { txnMessage } : { txnMessage: null }),
		...(commonTransactionMessage ? { commonTransactionMessage: 'true' } : { commonTransactionMessage: 'false' }),
		...(sendInAppNotificationAlso ? { sendInAppNotificationAlso: 'true' } : { sendInAppNotificationAlso: 'false' }),
		...(typeBucket === 'TYPE_MISCELLANEOUS' ? { txnHeading } : { txnHeading: null })
	};

	return { csvData };
};
